<template>
  <div
    class="file-drop-wrapper drop-inactive"
    v-bind:class="{ dropped: file }"
    @dragover="dragover"
    @dragleave="dragleave"
    @drop="drop"
  >
    <input
      type="file"
      id="assetsFieldHandle"
      class="hide-input"
      @change="onChange"
      ref="file"
      accept=".pdf"
      v-if="!file"
    />
    <label for="assetsFieldHandle" class="drop-area" v-if="!file">
      Povuci i ispusti <br />
      ili <span class="click-here">klikni ovdje</span>
    </label>

    <label for="assetsFieldHandle" class="mobile-drop-area" v-if="!file"> Učitaj dokument </label>

    <div class="file-for-save" v-if="file">
      <div>
        {{ file.name }}
      </div>
      <img src="@/assets/app-icons/fly-talks/trash.svg" alt="trash" @click="remove" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'FileInput',
  data() {
    return {
      file: null,
    };
  },
  methods: {
    onChange() {
      this.file = this.$refs.file.files[0];
      this.$emit('added', this.file);
    },
    remove() {
      this.file = null;
      this.$emit('removed');
    },
    dragover(event) {
      event.preventDefault();
      if (!event.currentTarget.classList.contains('drop-active')) {
        event.currentTarget.classList.remove('drop-inactive');
        event.currentTarget.classList.add('drop-active');
      }
    },
    dragleave(event) {
      event.currentTarget.classList.add('drop-inactive');
      event.currentTarget.classList.remove('drop-active');
    },
    drop(event) {
      event.preventDefault();
      this.$refs.file.files = event.dataTransfer.files;
      this.onChange();
      event.currentTarget.classList.add('drop-inactive');
      event.currentTarget.classList.remove('drop-active');
    },
  },
};
</script>

<style scoped>
.hide-input {
  visibility: hidden;
  position: absolute;
}

.file-drop-wrapper {
  cursor: pointer;
  box-sizing: border-box;
  border: 1px dashed rgba(255, 255, 255, 0.8);
  border-radius: 8px;
  margin-bottom: 40px;
  width: 100%;
  height: 120px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.drop-inactive {
  color: rgba(255, 255, 255, 0.8);
}

.file-for-save {
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
}

.drop-active {
  background-color: #30cec20d;
  border: 1px dashed #30cec2;
}

.drop-area {
  display: block;
  cursor: pointer;
  text-align: center;
}

.click-here {
  color: #30cec2;
}

.dropped {
  border: none;
  background-color: #ffffff0d;
  height: 64px;
  padding: 0 24px;
  margin-bottom: 96px;
}

.mobile-drop-area {
  display: none;
}

@media screen and (max-width: 1024px) {
  .file-drop-wrapper {
    border: 1px solid #ffffff;
    height: 56px;
    width: 55%;
    font-weight: 800;
  }

  .hide-input,
  .drop-area {
    display: none;
  }

  .dropped {
    border: none;
  }

  .mobile-drop-area {
    display: inline-block;
  }
}
</style>
